<div data-testid="revenue-coverage" class="coverage">
  <div class="coverage__header">
    <div class="coverage__titles">
      <h4 data-testid="coverage-title" class="coverage__title">{{ title }}</h4>
      <p data-testid="coverage-description" class="coverage__description">
        @if (coverage?.paying) {
          Revenue covers <b data-testid="coverage-covered">{{ coveredText }}</b> of {{ payingText }}. The rest have no Client Manager record, so no figure on this page includes them.
        } @else {
          How many paying companies have a Client Manager record.
        }
      </p>
    </div>
  </div>
  @if (failed) {
    <app-admin-dashboard-empty data-testid="coverage-failed" icon="fa-regular fa-circle-exclamation" [title]="failedTitle"
                               body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  } @else if (coverage?.paying) {
    <div data-testid="coverage-meter" class="coverage__meter" role="img" [attr.aria-label]="meterLabel">
      <span data-testid="coverage-meter-fill" class="coverage__meter-fill" [style.width.%]="coveredShare"></span>
    </div>
    @if (rows.length) {
      <ul data-testid="coverage-list" class="adb-list">
        @for (row of listed; track row.companyId) {
          <li data-testid="coverage-row" class="adb-list__row">
            <span class="adb-list__main">
              <button type="button" data-testid="coverage-company" class="adb-list__name" (click)="open360(row.companyId)">{{ row.companyName }}</button>
              <span data-testid="coverage-users" class="adb-list__reason">{{ row.activeUsers | adbCount:'active user' }}</span>
            </span>
            <span data-testid="coverage-when" class="adb-list__when">No CM record</span>
          </li>
        }
      </ul>
      @if (hasMore) {
        <button type="button" data-testid="coverage-toggle" class="coverage__toggle" (click)="toggle()">{{ toggleText }}</button>
      }
      @if (showAll && coverage.total > rows.length) {
        <p data-testid="coverage-more" class="coverage__note">Showing {{ rows.length | number }} of {{ coverage.total | number }}.</p>
      }
    } @else {
      <p data-testid="coverage-note" class="coverage__note">Every paying company in this view has a Client Manager record.</p>
    }
  } @else if (loaded) {
    @if (coverage) {
      <app-admin-dashboard-empty data-testid="empty" icon="fa-regular fa-building" title="No paying companies in this view"></app-admin-dashboard-empty>
    } @else {
      <app-admin-dashboard-empty data-testid="unavailable" icon="fa-regular fa-circle-exclamation" title="Coverage is not available"></app-admin-dashboard-empty>
    }
  }
</div>
